import { Result } from './data.models';
import { CategoryStanding } from './category-standings.models';

/** Medals refer to category places. Scratch positions never stand in for them. */
export function medalRank(result: Result): number | undefined {
  const rank = result.categoryRank;
  return result.timeSeconds > 0 && rank != null && Number.isInteger(rank) && rank > 0 ? rank : undefined;
}

export function withCategoryStanding<T extends Result>(result: T, standing?: CategoryStanding): T {
  const categoryRank = result.timeSeconds > 0 ? standing ? standing.rank : result.categoryRank : undefined;
  return { ...result, categoryRank, rank: categoryRank };
}

export function countPodiums(results: Result[]) {
  const counts = { first: 0, second: 0, third: 0, fourth: 0, total: 0 };
  for (const result of results) {
    const rank = medalRank(result);
    if (rank === 1) counts.first++;
    else if (rank === 2) counts.second++;
    else if (rank === 3) counts.third++;
    else if (rank === 4) counts.fourth++;
  }
  counts.total = counts.first + counts.second + counts.third;
  return counts;
}
